<template>
  <form>
    <div>
      <div class="form-title-container">
        <p>{{ isMedals ? "祝賀詞與名稱" : "宮廟名" }}</p>
        <div class="templeNameLimit" :class="{ 'is-over': isTempleNameOver }">
          <span>{{ templeNameLength }}</span>
          <span>/</span>
          <span>{{ templeNameLimit }}</span>
        </div>
      </div>
      <input
        id="templeNameInput"
        type="text"
        :placeholder="isMedals ? '例：恭祝 ＯＯＯ 生日快樂' : '例:天后宮'"
        v-model="engraving_content.content.templeName"
      />
    </div>
    <div>
      <div class="form-title-container">
        <p>{{ isMedals ? "祝賀詞" : "神明名" }}</p>
        <div class="godNameLimit" :class="{ 'is-over': isGodNameOver }">
          <span>{{ godNameLength }}</span>
          <span>/</span>
          <span>{{ godNameLimit }}</span>
        </div>
      </div>
      <input
        id="godNameInput"
        type="text"
        :placeholder="isMedals ? '例：鵬程萬里 心想事成' : '例:天上聖母'"
        v-model="engraving_content.content.godName"
      />
    </div>
    <div>
      <div class="form-title-container">
        <p>贈送人姓名（也可加上甲子年號、日期）</p>
        <div class="giftLimit" :class="{ 'is-over': isGiftOver }">
          <span>{{ giftLength }}</span>
          <span>/</span>
          <span>{{ giftLimit }}</span>
        </div>
      </div>
      <input
        id="giftInput"
        type="text"
        placeholder="例:王大明 乙亥年"
        v-model="engraving_content.content.gift"
      />
    </div>
    <div class="dropdown_title">
      <p class="title">{{ isMedals ? "贈詞" : "敬獻辭" }}</p>
      <a href="#" v-on:click.prevent="showDropDown = !showDropDown">
        <div class="title title-color" v-if="!isRespect">
          請選擇{{ isMedals ? "贈詞" : "敬獻詞" }}
        </div>
        <div class="title" v-else>{{ engraving_content.content.respect }}</div>
        <i
          :class="{
            'fa-caret-up': showDropDown,
            'fa-caret-down': !showDropDown,
          }"
          class="fa"
          aria-hidden="true"
        ></i>
      </a>
      <transition name="slide-fade">
        <div class="choice" v-if="showDropDown">
          <ul>
            <li v-for="(link, index) in links" :key="index">
              <span v-on:click="updateRespect(link)">{{ link }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <!-- <p class="note">示意圖的字型、位置會再經過師傅專業編排，如換行斷字有特殊要求者，可以於商品備注中標示。</p> -->
    <!-- <p class="note">畫面呈現為示意圖，非正式製作的稿件。請加入官方 Line@，後台會將製作的稿件傳送給您，做最後確認！</p> -->
    <p class="note">畫面呈現為示意圖，正式製作稿件將由專業人員編排製版完成。</p>
  </form>
</template>

<script>
export default {
  name: "MetalTextDefault",
  data() {
    return {
      showDropDown: false,
      engraving_content: {
        type: "default",
        content: {
          templeName: "",
          godName: "",
          gift: "",
          respect: "",
        },
      },
      templeNameLimit: "",
      godNameLimit: "",
      giftLimit: "",
    };
  },
  created() {
    this.engraving_content =
      this.$store.getters.currentCustom.engraving_content;

    let componentCode = this.$store.getters.getComponentCode;
    //取得字數限制並整理
    let textLimit =
      this.$store.getters.textSettingByComponentCode(componentCode);
    this.templeNameLimit =
      textLimit.templeName.lineLimit * textLimit.templeName.textLimit;
    this.godNameLimit =
      textLimit.godName.lineLimit * textLimit.godName.textLimit;
    this.giftLimit = textLimit.gift.lineLimit * textLimit.gift.textLimit;
  },
  watch: {
    "engraving_content.content": {
      handler() {
        this.updateCostom();
      },
      deep: true,
    },
  },
  computed: {
    isRespect() {
      return this.engraving_content.content.respect;
    },
    isMedals() {
      return this.$store.getters.isMedalsLabelDisplay;
    },
    links() {
      if (this.isMedals) {
        return ["賀", "同賀", "敬賀", "恭賀", "贈", "同贈", "敬贈"];
      } else {
        return ["敬賀", "恭賀", "祝賀", "敬獻", "喜獻", "叩敬", "敬謝", "叩謝"];
      }
    },
    // 字數計數
    templeNameLength() {
      return this.engraving_content.content.templeName.length;
    },
    godNameLength() {
      return this.engraving_content.content.godName.length;
    },
    giftLength() {
      return this.engraving_content.content.gift.length;
    },
    // 是否超過限制
    isTempleNameOver() {
      return this.templeNameLength > this.templeNameLimit;
    },
    isGodNameOver() {
      return this.godNameLength > this.godNameLimit;
    },
    isGiftOver() {
      return this.giftLength > this.giftLimit;
    },
    // 是否有任何欄位超過限制
    isAnyFieldOver() {
      return this.isTempleNameOver || this.isGodNameOver || this.isGiftOver;
    },
  },
  methods: {
    updateCostom() {
      let payload = {
        key: "engraving_content",
        content: this.engraving_content,
      };
      this.$store.dispatch("updateCostom", payload);
    },
    updateRespect(item) {
      this.engraving_content.content.respect = item;
      this.updateCostom();
      this.showDropDown = false;
    },
    checkoutTextLimit() {
      return this.isAnyFieldOver ? "over" : "ok";
    },
  },
};
</script>

<style scoped lang="scss">
.templeNameLimit,
.godNameLimit,
.giftLimit {
  color: #4a4a4a;
  transition: color 0.2s ease;

  &.is-over {
    color: red;
  }
}
</style>
